import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';

class PackageDialog extends Component {

    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.reset = this.reset.bind(this);
        this.handleShowHistory = this.handleShowHistory.bind(this);

        this.renderPackage = this.renderPackage.bind(this);
        this.renderRevisions = this.renderRevisions.bind(this);

        this.state = {
            error: '',
            modalOpen: false,
            current: null,
            history: null,
            showHistory: false,
            error: null
        };
    };

    reset() {
        this.setState({showHistory: false});
    };

    close() {
        this.setState({ 
            modalOpen: false
         });
    };

    open() {
        this.reset();
        this.setState({
            modalOpen: true
        });
    };

    handleShowHistory() {
        this.setState({
            showHistory: !this.state.showHistory
        })
    }

    componentDidMount() {
        ReactModal.setAppElement('#rm_PackageDialog');
        urlHandler.sendVersionRequest(true, (response, status) => {
            if (response.error_status) { 
                this.setState({
                    error: decodeURIComponent(response.error_message)
                })
            } else {
                this.setState({
                    current: 'current' in response ? response['current'] : null,
                    history: 'history' in response ? response['history'] : null,
                    error: null
                })
            }
        });
    }

    renderRevisions(revs) {
        var revisions = '<ul>';
        for (var i=0; i < revs.length; i++) {
            var next = revs[(i+1) % revs.length];
            var curr = revs[i];
            if (typeof curr === 'string' || curr instanceof String) {
                revisions += `<li>${curr}`;
            }
            if (Array.isArray(next)) {
                revisions += this.renderRevisions(next);
            } else {
                revisions += '</li>';
            }
        }
        revisions += '</ul>';
        return revisions;
    }

    renderPackage(pkg) {
        return <table className="package">
            <tbody>
                <tr>
                    <td className="left">
                        <span className="fa fa-archive package-icon"></span>
                    </td>
                    <td className="right">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="header">
                                        Version:
                                    </td>
                                    <td>
                                        {pkg && pkg.package ? pkg.package : 'N/A'}
                                    </td>
                                </tr>
                                {pkg && pkg.date &&
                                <tr>
                                    <td className="header">
                                        Date:
                                    </td>
                                    <td>
                                        {pkg.date}
                                    </td>
                                </tr>
                                }
                                {pkg && pkg.revisions &&
                                <tr>
                                    <td className="header">
                                        Revisions:
                                    </td>
                                    <td className="revision-value" 
                                        dangerouslySetInnerHTML={{ __html: this.renderRevisions(pkg.revisions)}}>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    }

    render() {

       const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '750px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
            <div id="rm_PackageDialog">
                <button className="link-button" onClick={this.open}>
                    {this.props.renderIcon ? <span className='fa fa-info-circle' data-tip data-for="package-tip"></span> : null}
                    {this.props.text}
                </button>
                <ReactTooltip id="package-tip" 
                    type={this.props.tooltipType}
                    offset={this.props.tooltipOffset} 
                    effect="solid" 
                    place={this.props.tooltipPlace}
                    disable={!this.props.tooltip}>
                    {this.props.tooltip}
                </ReactTooltip>
                <ReactModal ref="packageId"
                    isOpen={this.state.modalOpen} 
                    contentLabel="Package Information Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="package-dialog">
                        <div className="package-header">
                            Package Information
                        </div>
                        <div className="package-description">
                            {this.state.current &&
                                this.renderPackage(this.state.current)
                            }
                            <br/>
                            <div>
                                <button className="link-button" onClick={this.handleShowHistory}><span>{this.state.showHistory ? 'hide' : 'show'}</span> history ...</button>
                            </div>
                        </div>
                        <div>
                            {this.state.history && this.state.showHistory &&
                            <div className="package-content" key="history-panel">
                                {this.state.history.map((pkg, index) => {
                                    return (
                                        <div key={index} className="package-history">
                                            {this.renderPackage(pkg)}
                                        </div>
                                    )
                                })}
                            </div>
                            }
                        </div>
                        <div className="package-footer">
                            {this.state.error &&
                            <div className="package-error">
                                <span><span className="fa fa-exclamation-circle">&nbsp;</span>{this.state.error}</span>
                            </div>
                            }
                            <button type="button" className="package-default-button" onClick={this.close}>Ok</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

PackageDialog.defaultProps = {
    renderIcon: true,
    text: '',
    tooltip: null,
    tooltipType: 'dark',
    tooltipPlace: 'bottom',
    tooltipOffset: {bottom: 0, top: 0, left: 0, right: 0}
};

PackageDialog.propTypes = {
    renderIcon: PropTypes.bool,
    text: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipType: PropTypes.string,
    tooltipPlace: PropTypes.string,
    tooltipOffset: PropTypes.object
}

export default PackageDialog;

